import {logoutOperator} from '../../login/utils/LoginApi';
import {deleteCookie} from './CookieUtils';
import {toast} from 'react-toastify';

export async function get(url = '') {
  return handleErrorStatusCodes(await fetch(url, getDefaultOptions()));
}

export async function post(url = '', data = {}) {
  return handleErrorStatusCodes(await fetchWithBody(url, 'POST', data));
}

export async function put(url = '', data = {}) {
  return handleErrorStatusCodes(await fetchWithBody(url, 'PUT', data));
}

function handleErrorStatusCodes(response) {
  switch (response.status) {
  case 401:
    window.location.href = '/';
    deleteCookie('loggedInIndicator');
    throw new Error('user not authenticated.');
  case 403:
    toast.error('No permission - Click here to Logout', {
      onClick: async () => {
        await logoutOperator();
        window.location.href = '/';
      },
    });
    throw new Error('user does not have the permission to perform this action.');
  }

  return response;
}

function fetchWithBody(url = '', method, data = {}) {
  return fetch(url, {
    ...getDefaultOptions(),
    method: method,
    headers: {
      'Content-Type': 'application/json',
    },
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(data),
  });
}

function getDefaultOptions() {
  return {
    mode: 'same-origin',
  };
}
